import React from "react";
import Typical from "react-typical";
import photo from "../../images/Naim-redShirt.jpg";

const Header = () => {
  return (
    <div className="header-wrapper">
      <div className="main-info">
        <img className="photoClass" src={photo} alt="" />
        <h2>Hey there! I am</h2>
        <h1>Naimul Alam</h1>
        <Typical
          loop={Infinity}
          wrapper="b"
          className="typical-text"
          steps={[
            "Web Developer",
            1000,
            "IT Graduate",
            1000,
            "React Developer",
            1000,
            "UX/UI Designer",
            1000,
          ]}
        />
        <div className="container-fluid m-3">
          <a
            className="btn-main-resume"
            href="https://drive.google.com/u/1/uc?id=1SpIfpE_wf9KgskJNhql98o8GIMvqOyT2&export=download"
          >
            Resume
          </a>
          <a
            className="btn-main-resume"
            href="https://www.linkedin.com/in/naimul-alam/"
            rel="noopener noreferrer"
            target="_blank"
          >
            Hire Me
          </a>
        </div>
      </div>
    </div>
  );
};

export default Header;
